module.exports = __webpack_public_path__ + "static/media/bell.9bb4fdfe.svg";